import styled, { createGlobalStyle } from 'styled-components';

export const GlobalCalendarStyle = createGlobalStyle`
  .ant-picker-dropdown {
    .ant-picker-panel {
      background-color: white !important;
      
      .ant-picker-body {
        background-color: white !important;
      }
      
      .ant-picker-content {
        background-color: white !important;
        
        table {
          background-color: white !important;
        }
        
        .ant-picker-cell {
          background-color: white !important;
          
          .ant-picker-cell-inner {
            color: black !important;
            background-color: white !important;
          }
        }
      }
      
      .ant-picker-header {
        background-color: white !important;
        
        .ant-picker-header-view {
          button {
            color: black !important;
          }
        }
      }
    }
  }
`;

export const DatePickerWrapper = styled.div`
  padding: unset !important;

  .ant-picker {
    min-width: 120px;

    // Input text
    .ant-picker-input input {
      color: black !important;
    }

    // Placeholder text
    .ant-picker-placeholder {
      color: black !important;
    }

    // Selected date text
    .ant-picker-input > input {
      color: black !important;
    }

    // Focused border color
    &.ant-picker-focused {
      border-color: black;
    }

    .ant-picker-input {
      svg {
        color: grey;
      }
    }
  }
`;
